export const acronymTypes = {
    "AD": { name: "Aldea" },
    "AL": { name: "Alameda" },
    "AP": { name: "Apartamento" },
    "AV": { name: "Avenida" },
    "BL": { name: "Bloque" },
    "BO": { name: "Barrio" },
    "CH": { name: "Chalet" },
    "CL": { name: "Calle" },
    "CM": { name: "Camino" },
    "CO": { name: "Colonia" },
    "CR": { name: "Carretera" },
    "CS": { name: "Caserío" },
    "CT": { name: "Cuesta" },
    "ED": { name: "Edificio" },
    "GL": { name: "Glorieta" },
    "GR": { name: "Grupo" },
    "LG": { name: "Lugar" },
    "MC": { name: "Mercado" },
    "MN": { name: "Municipio" },
    "MZ": { name: "Manzana" },
    "PB": { name: "Poblado" },
    "PG": { name: "Polígono" },
    "PJ": { name: "Pasaje" },
    "PQ": { name: "Parque" },
    "PR": { name: "Prolongación" },
    "PS": { name: "Paseo" },
    "PZ": { name: "Plaza" },
    "RB": { name: "Rambla" },
    "RD": { name: "Ronda" },
    "TR": { name: "Travesía" },
    "UR": { name: "Urbanización" }
};

export function getAcronymIdByName(name) {
    for (const [key, value] of Object.entries(acronymTypes)) {
        if (value.name === name) {
            return key;
        }
    }
    return null; // Retorna null si no se encuentra
}

export function getAcronymNameById(id) {
    const acronym = acronymTypes[id];
    return acronym ? acronym.name : null; // Retorna el nombre si existe, de lo contrario null
}
